import { DotLottieWorkerReact } from '@lottiefiles/dotlottie-react'
import cn from 'classnames'
import React, { memo, useEffect, useState } from 'react'

import { DiamondAnimation } from '@shared'

import styles from './CameraCardFolder.module.scss'

type Props = {
  number: number
  title: string
  img: string
  renderMask: (children: React.ReactNode) => React.ReactNode
  isAnimated?: boolean
}

export const CameraCardFolder = memo(
  ({ number, title, img, renderMask, isAnimated = false }: Props) => {
    const [data, setData] = useState<string>()

    useEffect(() => {
      if (isAnimated) {
        fetch('/lottie/particles_for_text.json')
          .then((res) => res.json())
          .then((data) => {
            setData(data)
          })
      }
    }, [isAnimated])

    const maskContent = (
      <>
        <img src={img} alt="example" className={styles.photo} />
        <div className={styles['folder-title']}>
          <div className={styles['folder-number']}>
            х{number}
          </div>
          <div className={styles['folder-text']}>{title}</div>
        </div>
      </>
    )

    return (
      <div className={styles.container}>
        {isAnimated && data && (
          <>
            <DotLottieWorkerReact
              data={data}
              className={cn(styles.lottie, styles['lottie--top'])}
              autoplay
              loop
              workerId="particles_for_text"
              renderConfig={{
                autoResize: true,
              }}
            />
            <DotLottieWorkerReact
              data={data}
              className={cn(styles.lottie, styles['lottie--bottom'])}
              autoplay
              loop
              workerId="particles_for_text"
              renderConfig={{
                autoResize: true,
              }}
            />
          </>
        )}

        {isAnimated && (
          <svg viewBox="0 0 199 183" fill="none" className={styles.diamond}>
            <DiamondAnimation optimized />
          </svg>
        )}

        {renderMask(maskContent)}
      </div>
    )
  }
)

CameraCardFolder.displayName = 'CameraCardFolder'
